'use client';

import DefaultError from '@/src/app/_components/default-error';

export default function Error(props: { error: Error; reset: () => void }) {
  return <DefaultError key={'root'} {...props} />;
}
